module.exports = __webpack_public_path__ + "static/media/img5.03935b4f.jpg";